module.exports = __webpack_public_path__ + "img/ic_baby.576d9198.svg";